<template>
    <div class="style-form py-5">
      <div class="col-11 col-md-9 mx-auto">
        <h2 class="color-palette-2 font-weight-bold">Déjanos tus datos</h2>
      </div>
      <div class="col-12 col-md-10 mx-auto">
        <form id="form-ds49" class="row" @submit.prevent="sendDs49Form" method="POST">
          <input type="hidden" name="_token" :value="csrf">
          <input type="hidden" name="commune_id" :value="form.commune_id">
          <input type="hidden" name="hasSubsidy" :value="form.hasSubsidy">
          <input type="hidden" name="hasUfSaving" :value="hasUfSaving ? 1 : 0">
          <input type="hidden" name="hasRsh" :value="hasRsh ? 1 : 0">
          <div class="col-12 col-md-6">
            <input type="text" placeholder="Nombre y apellido"
                name="name"
                v-model.trim="$v.form.name.$model"
               :class="!$v.form.name.$anyError? 'form-control w-100': 'form-control w-100 form-error'">
               <div class="error-data" v-if="$v.form.name.$dirty">
                  <span v-if="!$v.form.name.required">Campo necesario</span>
              </div>
          </div>
          <div class="col-12 col-md-6">
            <v-select-c
              id="select-commune"
              style="border-radius: 5px !important;"
              v-model="$v.form.commune_id.$model"
              :options="communes"
              label="name"
              :class="!$v.form.commune_id.$anyError? '': 'form-error'"
              :reduce="name => name.id"
              placeholder="¿Dónde Vives?">
            </v-select-c>
            <div class="error-data" v-if="$v.form.commune_id.$dirty">
                <span v-if="!$v.form.commune_id.required">Campo necesario</span>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <v-select-c
              id="select-has-subsidy"
              style="border-radius: 5px !important;"
              v-model="$v.form.hasSubsidy.$model"
              :options="has_subsidy_options"
              label="text"
              :class="!$v.form.hasSubsidy.$anyError? '': 'form-error'"
              :reduce="text => text.id"
              placeholder="¿Tienes subsidio?">
            </v-select-c>
            <div class="error-data" v-if="$v.form.hasSubsidy.$dirty">
                <span v-if="!$v.form.hasSubsidy.required">Campo necesario</span>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <input type="text" placeholder="Email"
                name="email"
                v-model.trim="$v.form.email.$model"
               :class="!$v.form.email.$anyError? 'form-control w-100': 'form-control w-100 form-error'">
               <div class="error-data" v-if="$v.form.email.$dirty">
                  <span v-if="!$v.form.email.required">Campo necesario</span>
                  <span v-if="!$v.form.email.email">Email inválido</span>
               </div>
          </div>
          <div class="col-12 col-md-6">
            <input type="text" placeholder="Rut"
                name="rut"
                v-model.trim="$v.form.rut.$model"
                v-rut:live
               :class="!$v.form.rut.$anyError? 'form-control w-100': 'form-control w-100 form-error'">
               <div class="error-data" v-if="$v.form.rut.$dirty">
                  <span v-if=" !$v.form.rut.rutValidation || !$v.form.rut.minLength">RUT Inválido</span>
              </div>
          </div>
          <div class="col-12 col-md-6">
            <input type="text" placeholder="Teléfono"
                name="phone"
                maxlength="9"
                @keypress="onlyNumber"
                v-model.trim="$v.form.phone.$model"
               :class="!$v.form.phone.$anyError? 'form-control w-100': 'form-control w-100 form-error'">
               <div class="error-data" v-if="$v.form.phone.$dirty">
                  <span v-if="!$v.form.phone.required">Campo necesario</span>
                  <span v-if="!$v.form.phone.minLength">Teléfono inválido</span>
                  <span v-if="!$v.form.phone.maxLength">Teléfono inválido</span>
               </div>
          </div>
          <div class="col-12 py-1 ml-4">
            <div class="form-group mb-0">
              <input class="form-check-input" type="checkbox" id="defaultCheck1" v-model="hasUfSaving">
              <label class="form-check-label color-text-default" for="defaultCheck1">
                Tienes 10 UF de ahorro
              </label>
            </div>
          </div>
          <div class="col-12 py-1 ml-4">
            <div class="form-group mb-0">
              <input class="form-check-input" type="checkbox" id="defaultCheck2" v-model="hasRsh">
              <label class="form-check-label color-text-default" for="defaultCheck2">
                Posee el registro social de hogares
              </label>
            </div>
          </div>
          <div class="col-12">
            <privacy-consent
              id="ds49-privacy"
              v-model="$v.form.privacy.$model"
              :invalid="$v.form.privacy.$dirty && !$v.form.privacy.accepted"
            />
          </div>
          <div class="col-12">
            <div class="col-12 col-md-5 ml-auto pr-0 pl-0 pl-md-3">
              <button type="submit" :disabled="formLoading" class="btn bg-color-palette-3 text-white btn-block">
                {{btnText}}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import { required, minLength, email, maxLength } from "vuelidate/lib/validators";
  import { rutValidator, rutInputDirective } from "vue-dni";
  import PrivacyConsent from "../../components/PrivacyConsent.vue";

  import Vue from "vue";
  Vue.directive("rut", rutInputDirective);

  const accepted = (value) => value === true;
  
  export default {
    name: "inscribete-ds49",
    components: { PrivacyConsent },
    props: {
      communes: ''
    },
    data: () => ({
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      formLoading: false,
      btnText:"Enviar",
      hasUfSaving: 0,
      hasRsh: 0,
      form: {
          name: "",
          rut: "",
          email: "",
          phone: "",
          commune_id: "",
          hasSubsidy: "",
          hasUfSaving: "",
          hasRsh: "",
          privacy: false,
      },
      has_subsidy_options: [
        {id: 1, text: 'Si'},
        {id: 0, text: 'No'}
      ]
    }),
    methods: {
      sendDs49Form() {
        this.$v.form.$touch();
        if (!this.$v.form.$invalid) {
          this.btnText = "Enviando...";
          this.formLoading = true;
          const rutaForm = window.BASE_URL + '/add-ds49-form'
          $('#form-ds49').attr('action', rutaForm).submit();
        }
      },
      onlyNumber ($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
    },
    validations: {
      form: {
        rut: {
          required,
          rutValidation: rutValidator,
          minLength: minLength(9),

        },
        name: {
          required,
        },
        phone: {
          required,
          minLength: minLength(9),
          maxLength: maxLength(9)
        },
        email: {
          required,
          email,
        },
        commune_id: {
          required,
        },
        hasSubsidy: {
          required,
        },
        privacy: { accepted },
      },
    },
  };
  </script>
  
  <style scoped>
  .style-form {
    border-radius: 9px;
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
    background-color: #fff;
  }
  
  .icon-style {
    font-size: 3rem !important;
  }

  .color-text-default {
    color: #707070;
  }
  
  </style>
